<template>
  <div class="link" data-cy="expand-button" @click="$emit('toggle-expanded')">
    {{ title }}<i class="ml-1 align-middle" :class="chevronIcon"></i>
  </div>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["toggle-expanded"],
  computed: {
    chevronIcon() {
      return this.expanded ? "fas fa-chevron-up" : "fas fa-chevron-down";
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  display: inline;
  font-size: 1.1em;
}
</style>
